import { Box, Typography } from "@mui/material";
import HistoryTable from "./history";
import SearchValidateTable from "./search-and-validate";
import { useState } from "react";

const TicketsValidationPage = () => {
  const [forceRefetch, setForceRefetch] = useState(false);

  return (
    <Box p={"30px"}>
      <Typography mb={{ xs: 2, md: 4 }} fontSize={"20px"} fontWeight={600}>
        Tickets Validation
      </Typography>
      <SearchValidateTable
        setForceRefetch={setForceRefetch}
        forceRefetch={forceRefetch}
      />
      <Typography mt={4} mb={2} fontSize={"20px"} fontWeight={600}>
        Recent Validations
      </Typography>
      <HistoryTable forceRefetch={forceRefetch} />
    </Box>
  );
};

export default TicketsValidationPage;
